import "./OurStory.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurRootsInTexas from "./sections/OurRootsInTexas";
import TheExpertTeam from "./sections/TheExpertTeam";
import OurImpact from "./sections/OurImpact";
import Readytosecurecanopycta from "./sections/Readytosecurecanopycta";
import SiteFooter from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <MainNavigation />
      <OurRootsInTexas />
      <TheExpertTeam />
      <OurImpact />
      <Readytosecurecanopycta />
      <SiteFooter />
    </div>;
}